

import { mapState, mapGetters } from 'vuex'
import { mdiInformation, mdiArrowDownThin, mdiLockOutline } from '@mdi/js'
import ProductListingItemCountryFlag from './ProductListingItemCountryFlag.vue'

import CountDown from '@/components/catalog/product/CountDown'
import time from '@/components/tools/time'
import ObfuscateTooltip from '@/components/catalog/ObfuscateTooltip'
import auction from '@/components/tools/auction'
import utils from '@/components/tools/utils'
import ProductListingItemImage from '@/components/catalog/ProductListingItemImage'
import CustomerContextOwnerProductChip from '@/components/catalog/chips/CustomerContextOwnerProductChip'
import AuctionStatusChip from '@/components/catalog/chips/AuctionStatusChip'
import BuyNowProductChip from '@/components/catalog/chips/BuyNowProductChip'
import CustomerContextProductChip from '@/components/catalog/chips/CustomerContextProductChip'
import PrivateAuctionProductChip from '@/components/catalog/chips/PrivateAuctionProductChip'
import TrailerListingDataChips from '@/components/catalog/product/listing/TrailerListingDataChips'
import MotorhomeListingDataChips from '@/components/catalog/product/listing/MotorhomeListingDataChips'
import OldTargetPriceTooltip from '@/components/catalog/product/OldTargetPriceTooltip.vue'
import auctionHistory from '@/components/tools/auctionHistory'

export default {
  name: 'ProductListingItem',
  icons: {
    mdiLockOutline,
    mdiInformation,
    mdiArrowDownThin
  },
  components: {
    OldTargetPriceTooltip,
    MotorhomeListingDataChips,
    TrailerListingDataChips,
    PrivateAuctionProductChip,
    CustomerContextProductChip,
    BuyNowProductChip,
    AuctionStatusChip,
    CustomerContextOwnerProductChip,
    ProductListingItemImage,
    ObfuscateTooltip,
    CountDown,
    ProductListingItemCountryFlag
  },
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({ isAdmin: 'isUserAdmin' }),
    ...mapState('customer', {
      merchantAcceptedByCm24: state => state.merchant?.acceptedByCm24 === true,
      customer: state => state.customer,
      merchantAddress: state => state.merchantAddress
    }),

    numberOfAuctions () {
      return auctionHistory.getNumberOfAuctions(this.product.auction.history?.numberOfAuctions, this)
    },

    maxWidthTooltip () {
      if (this.$vuetify.breakpoint.mobile) {
        return '60vw'
      } else {
        return '40vw'
      }
    },
    vatReportable () {
      return this.product.auction.vatReportable
    },
    vatPercentage () {
      if (this.product.vatPercentage) {
        return this.product.vatPercentage
      } else {
        return 19
      }
    },
    countryCode () {
      return this.product.position.countryCode === 'DE' ? 'D' : this.product.position.countryCode
    }
  },
  methods: {
    obfuscatePrice (product) {
      if (this.isOwner(product)) {
        return false
      } else if (this.merchantAcceptedByCm24) {
        return false
      }

      return true
    },
    endingAt (product) {
      if (product.auction.renegEndingAt) {
        return time.parseDate(product.auction.renegEndingAt)
      } else {
        return time.parseDate(product.auction.endingAt)
      }
    },
    startingAt (product) {
      return time.parseDate(product.auction.startingAt)
    },
    auctionPriceTitle (product, isOwner) {
      return auction.auctionPriceTitle(product, isOwner, this.$auth.loggedIn)
    },
    isOwner (product) {
      return this.$store.state?.customer?.customer?.customerId === product?.customerId
    },
    hasBids (product) {
      return product.auction.hasBids
    },

    currentPriceColor (product) {
      return utils.currentPriceColor(product)
    },
    formatCurrency (value) {
      return utils.formatCurrency(value)
    },
    getPercentageDifference (a, b) {
      return utils.getPercentageDifference(a, b)
    },

    targetPrice (product) {
      if (product.auction.targetPrice) {
        return this.formatCurrency(product.auction.targetPrice)
      } else {
        return '-'
      }
    },
    buyNowPrice (product) {
      if (product.auction.buyNowPrice) {
        return this.formatCurrency(product.auction.buyNowPrice)
      } else {
        return undefined
      }
    },
    buyNowEnabled (product) {
      return product.auction?.buyNowEnabled && product.auction?.buyNowPrice != null &&
        product.auction.hasBids === false && product.auction.autoRound === false
    },
    auctionFee (product) {
      if (product.auction?.auctionFee && product?.auction?.auctionFeeVat) {
        return product.auction.auctionFee + product.auction.auctionFeeVat
      } else {
        return 0
      }
    },
    privateAuction (product) {
      return product?.auction?.privateAuction
    },
    hasBiddingContext (product) {
      return !(product?.context?.holdingHighestBid === undefined || product?.context?.holdingHighestBid === null) ||
        product.context?.hasFailedLateOfferOnProduct === true
    },
    isTrailer (product) {
      return product?.productType === 'trailer'
    },
    toggle () {
      this.isExpanded = !this.isExpanded
    },
    distanceToMyLocation (product) {
      if (product.context?.distanceToMyLocation) {
        return product.context?.distanceToMyLocation + ' km'
      } else {
        return null
      }
    }
  }
}
